import gql from 'graphql-tag'
import { ILogger } from '@qest/logger-utils'

export const GET_LOCAL_SUGGEST_HISTORY_PRODUCTS = gql`
  query {
    suggestHistoryProducts @client {
      id
      title
      availability {
        isAvailable
        key
      }
      price
      isAdultOnly
      fullUrl
      mediaId
    }
  }
`

export const DELETE_ALL_LOCAL_SUGGEST_HISTORY_PRODUCTS = gql`
  mutation {
    deleteAllSuggestHistoryProducts @client
  }
`

export const getSuggestHistoryProductsFromStorage = (logger: ILogger) => {
  if (process.client) {
    try {
      const lastVisitedProductsString =
        window.localStorage.getItem('lastVisitedProducts') ?? JSON.stringify([])
      return JSON.parse(lastVisitedProductsString)
    } catch (error) {
      logger.error('getSuggestHistoryProductsFromStorage', error)
    }
  }
  return []
}
